import loadable from '@loadable/component';

import './ProfileEdit.css';

export default loadable(() => {
  return import('./ProfileEdit.jsx');
});
